module.exports = __webpack_public_path__ + "static/media/cat.ae00415.webm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cat.webm
// module id = wh8N
// module chunks = 1